import { useQueryClient } from '@tanstack/react-query';

import {
  getApiV1LocationStatesQueryOptions,
  useDeleteApiV1LocationStatesId,
} from '@/shared/api/generated';

/**
 * Hook para excluir um Estado.
 *
 * Envolve o mutation gerado pelo Kubb para `DELETE /api/v1/location/states/{id}`
 * e invalida o cache da listagem após a exclusão bem-sucedida.
 */
export function useDeleteState() {
  const queryClient = useQueryClient();

  return useDeleteApiV1LocationStatesId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1LocationStatesQueryOptions());
      },
    },
  });
}
